// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { styledBox } from "@mcmc/XDL/Components/Common/Box";
import { css } from "styled-components";

const imgHeight = 185;

const wrapper: InjectableCss = {
    css: [
        css`
            ${styledBox}
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            padding: 0;
            margin-bottom: 0;
            transition: box-shadow 0.2s ease-in-out;
            padding: 0 30px 20px 30px;

            &::after {
                content: "";
                position: absolute;
                display: block;
                width: 100%;
                border: 1px solid ${getColor("common.ui3")};
                left: 0;
                top: ${imgHeight}px;
                z-index: 1;
            }

            ${typeof document !== "undefined" && navigator?.userAgent.search("Firefox") > -1 && css`
                @media print {
                    break-inside: avoid;
                }
            `}
        `,
    ],
};

const image: LazyImageProps = {
    height: `${imgHeight}px`,
    width: "100%",
    css: css`
        margin-bottom: 30px;
    `,
};

const textContentWrapper: InjectableCss = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1 1 auto;
    `,
};

const heading: TypographyPresentationProps = {
    css: [
        css`
            height: 42px;
            overflow: hidden;
            text-transform: none;
            margin-bottom: 15px;

            p,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                font-size: 18px;
                line-height: 21px;
                margin-bottom: 0;
            }
        `,
    ],
};

const copyWrapper: InjectableCss = {
    css: css`
        margin-bottom: 15px;
        flex: 1 1 auto;
    `,
};

const copyText: TypographyPresentationProps = {
    variant: "p",
    size: "14px",
    lineHeight: "18px",
    css: css`
        max-height: 54px;
        overflow: hidden;
    `,
};

const buttonsWrapper: InjectableCss = {
    css: css`
        margin-top: 10px;
    `,
};

const button: ButtonPresentationProps = {
    sizeVariant: "medium",
    css: css`
        width: 100%;
        margin-bottom: 10px;
    `,
};

const styles = {
    wrapper,
    image,
    textContentWrapper,
    heading,
    copyWrapper,
    copyText,
    buttonsWrapper,
    button,
};

export default styles;
